import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
/**
 *
 * @param {object} props
 * @param {string} props.label
 * @param {string} props.name
 * @param {{text: string, value: string | number}[]} props.options
 * @param {function} props.onChange
 * @param {boolean} props.multi
 * @returns
 */
const SelectComponent = (props) => {
  const { prop, label, value, options = [], onChange, multi, required, valid, invalid } = props;
  let values;
  if (typeof value === 'string') {
    values = value.split(',');
  } else if (Array.isArray(value)) {
    values = value;
  } else if (value === undefined || value === null) {
    values = [];
  } else {
    values = [value];
  }

  const isChecked = (v) => {
    return values.includes(v);
  };
  const onChangeCore = (v) => (e) => {
    if (!multi) {
      onChange(v);
    } else {
      if (e.target.checked && !values.includes(v)) {
        values.push(v);
      } else {
        values.splice(values.indexOf(v), 1);
      }
      onChange(values.join(','));
    }
  };
  return (
    <>
      <Label for={prop}>
        {required && <span className="text-danger mr-1 align-middle">*</span>}
        {label}:
      </Label>
      <br />
      {options.map((option) => (
        <FormGroup check inline key={option.text}>
          <Input
            checked={isChecked(option.value)}
            type={multi ? 'checkbox' : 'radio'}
            onChange={onChangeCore(option.value)}
            invalid={invalid}
          />
          <Label check>{option.text}</Label>
        </FormGroup>
      ))}
    </>
  );
};

export default SelectComponent;
